import styled from 'styled-components';
import ListViewIcon from '../../../../new-components/svg-icons/ListViewIcon';
import { useTranslation } from 'next-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  setCompoundViewBounds,
  setResultsType,
  setSearchView
} from '../../../../redux/slices/mapSlice';
import { SearchViewTypes } from '../../../../new-lib/constants/common';
import { useRouter } from 'next/router';
import { logEvent } from '../../../../new-lib/analytics';
import { ResultsType } from '../../types';

const ListViewBtn = () => {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const router = useRouter();

  const handleClick = () => {
    if (router.asPath.includes('sahel-map')) {
      router.push(
        {
          pathname: '/search',
          query: { view: SearchViewTypes.LIST, areas: 3 }
        },
        undefined,
        { shallow: true }
      );
    } else {
      router.push(
        {
          pathname: router.pathname,
          query: { ...router.query, view: SearchViewTypes.LIST }
        },
        undefined,
        { shallow: true }
      );
    }
    dispatch(setSearchView(SearchViewTypes.LIST));
    dispatch(setResultsType(ResultsType.AREAS));
    dispatch(setCompoundViewBounds(null));
    logEvent.click('Map_list_view', 'Map', 'Map');
  };
  const drawerOpen = useSelector((state: any) => state.map.drawerOpen);
  return (
    <Container
      onClick={handleClick}
      drawerOpen={drawerOpen}
      locale={router.locale || 'en'}
    >
      <ListViewIcon />
      <span>{t('list_view')}</span>
    </Container>
  );
};

const Container = styled.button<{ drawerOpen: boolean; locale: string }>`
  display: flex;
  align-items: center;
  width: 200px;
  height: 40px;
  justify-content: center;
  gap: 4px;
  cursor: pointer;
  background-color: #fff;
  border-radius: 360px;
  padding: 4px 16px;
  color: #015c9a;
  font-family: materialSemiBold;
  box-shadow:
    0px 0px 4px 0px rgba(0, 0, 0, 0.1),
    0px 4px 8px 0px rgba(0, 0, 0, 0.15);
  border: none;
  outline: none;
  position: absolute;
  bottom: 38px;
  inset-inline-start: ${props =>
    props.drawerOpen ? 'calc( 50% - 170px)' : '50%'};
  transform: ${props =>
    props.locale == 'en' ? 'translateX(-50%)' : 'translateX(50%)'};
  z-index: 9;
  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    bottom: 30px;
    inset-inline-start: 50%;
  }
`;

export default ListViewBtn;
